// 바텀시트 범용 훅

import { useState } from 'react'

export const useBottomsheet = () => {
  // const [isOpen, setIsOpen] = useState(false)
  const [sheetType, setSheetType] = useState(null);
  const open = (type) => setSheetType(type);
  const close = () => setSheetType(null);
  const isOpen = sheetType !== null;

  return {open, close, sheetType, isOpen};
}